/* eslint react-hooks/exhaustive-deps: "warn" */


import { Icon } from 'ui/atoms/Icon/Icon';
import { Section } from 'ui/molecules/Section/Section';

import styles from './McpClientsSection.module.scss';

type Client = {
  icon: string;
  label: string;
};

const CLIENTS: Client[] = [
  { icon: 'tools-2', label: 'Claude' },
  { icon: 'tools-1', label: 'ChatGPT' },
  { icon: 'tools-7', label: 'Gemini' },
  { icon: 'tools-3', label: 'Cursor' },
  { icon: 'tools-5', label: 'Windsurf' },
  { icon: 'tools-8', label: 'Your own agents' },
];

export const McpClientsSection = () => {
  return (
    <Section
      fullWidth
      title="Works with every MCP client"
      description="MCP works across every leading AI surface. One connection — your AI tools chain Global Database queries automatically."
      className={styles.section}
    >
      <div className={styles.row}>
        {CLIENTS.map((client) => (
          <span key={client.label} className={styles.pill}>
            <Icon type={client.icon} className={styles.pillIcon} />
            <span className={styles.pillLabel}>{client.label}</span>
          </span>
        ))}
      </div>
    </Section>
  );
};
